module.exports = __webpack_public_path__ + "static/media/error.d5d072ab.jpg";